/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_Place_QuestionInputs */

const en_us2_onboarding_equipment_place_question = /** @type {(inputs: Onboarding_Equipment_Place_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where will you train?`)
};

const pt_br2_onboarding_equipment_place_question = /** @type {(inputs: Onboarding_Equipment_Place_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde você vai treinar?`)
};

const es_419_onboarding_equipment_place_question = /** @type {(inputs: Onboarding_Equipment_Place_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde vas a entrenar?`)
};

const pt_pt2_onboarding_equipment_place_question = /** @type {(inputs: Onboarding_Equipment_Place_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde vais treinar?`)
};

const fr_fr2_onboarding_equipment_place_question = /** @type {(inputs: Onboarding_Equipment_Place_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où vas-tu t'entraîner ?`)
};

const de_de2_onboarding_equipment_place_question = /** @type {(inputs: Onboarding_Equipment_Place_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo wirst du trainieren?`)
};

const it_it2_onboarding_equipment_place_question = /** @type {(inputs: Onboarding_Equipment_Place_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove ti allenerai?`)
};

/**
* | output |
* | --- |
* | "Where will you train?" |
*
* @param {Onboarding_Equipment_Place_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_place_question = /** @type {((inputs?: Onboarding_Equipment_Place_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_Place_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_place_question(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_place_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_place_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_place_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_place_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_place_question(inputs)
	return en_us2_onboarding_equipment_place_question(inputs)
});
export { onboarding_equipment_place_question as "onboarding.equipment_place.question" }